import { TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import LexoSwitch from '@/components/LexoSwitch';
import useQuoteIntakeSetupStore from '@/stores/useQuoteIntakeSetupStore';
import { theme } from '@/theme';

export default function PostIntakeEmailTemplate() {
    const [formData, setFormData, setErrorData, errorData] = useQuoteIntakeSetupStore((state) => [
        state.formData,
        state.setFormData,
        state.setErrorData,
        state.errorData,
    ]);

    const handleStateChange = (event: any, key: string) => {
        setErrorData({
            ...errorData,
            step5: {
                postIntakeEmailTemplateError: undefined,
            },
        });
        setFormData('step5', {
            ...formData.step5,
            [key]: event.target.value,
        });
        setFormData('step0', {
            ...formData.step0,
            [key]: event.target.value,
        });
    };

    return (
        <Box
            sx={{
                borderRadius: '8px',
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                backgroundColor: 'neutral.white',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                height: 'fit-content',
                width: '100%',
                margin: '10px 0px 32px 32px',
            }}
        >
            <Box>
                <Typography variant="h2">Post intake email template</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                <Typography variant="body2">Send post-intake submission email.</Typography>
                <LexoSwitch
                    checked={formData.step0.isPostIntakeEnable}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        const ev = { target: { value: event.target.checked } };
                        handleStateChange(ev, 'isPostIntakeEnable');
                    }}
                />
            </Box>
            {formData.step0.isPostIntakeEnable && (
                <Box
                    sx={{
                        display: 'flex',
                        position: 'relative',
                    }}
                >
                    <TextField
                        value={formData.step5.postIntakeSubject}
                        onChange={(ev) => handleStateChange(ev, ev.target.name)}
                        fullWidth
                        placeholder="Subject"
                        name={'postIntakeSubject'}
                        error={!!errorData.step5.postIntakeEmailTemplateError}
                        helperText={errorData.step5.postIntakeEmailTemplateError}
                        type="text"
                        variant="outlined"
                        label="Subject"
                    />
                </Box>
            )}
        </Box>
    );
}
